import React, { type ReactElement } from 'react'

import { useMediaQueries } from 'hooks'

import { urlTo } from 'helpers/router.js'

import Button from 'components/_old/Button/Button.jsx'
import Footer from 'components/_old/Footer/Footer.jsx'
import Header from 'components/_old/Header/Header.jsx'
import Inner from 'components/_old/Inner/Inner.jsx'
import Link from 'components/_old/Link/Link.jsx'
import { Progress } from 'components/_old/Progress/'

import { Gateway } from 'components/atoms/Gateway'

type LayoutProps = {
  children: ReactElement
  params: {
    goalId: string
    [key: string]: any
  }
  progressFill: number
  backLinkModule: string
  backLinkText: string
  location: {
    query?: {
      back?: string
    }
    [key: string]: any
  }
}

const Layout = ({
  children,
  params,
  progressFill,
  backLinkModule,
  backLinkText: initialBackLinkText,
  location,
}: LayoutProps): ReactElement => {
  const { desktop } = useMediaQueries()
  const backLinkUrl = location.query?.back ?? urlTo(backLinkModule, params)
  const backLinkText = desktop ? initialBackLinkText : 'Back'

  const headerLeft = <Link to={backLinkUrl}>{backLinkText}</Link>

  const headerRight = desktop && (
    <Button mods={{ theme: 'simple-reverse-blue', size: 'small', text: 'smaller' }}>
      <Link to={urlTo('dashboard')} classnameless>
        My Dashboard
      </Link>
    </Button>
  )

  const headerAfter = <Progress fill={progressFill} gapWidth="1em" />

  const header = <Header left={headerLeft} right={headerRight} after={headerAfter} hideDrawer />

  return (
    <section className="Layout-Holder">
      {desktop && header}
      {!desktop && <Gateway into="beforeLayout">{header}</Gateway>}
      <div className="Layout-Holder Layout-Content Layout-YearlyReview">
        <Inner className="Layout-Holder">{React.cloneElement(children, { params, backLinkUrl, backLinkText })}</Inner>
      </div>
      {desktop ? <Footer /> : null}
    </section>
  )
}

export { Layout }
